import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Panel } from "primereact/panel";
import { formatDateTime } from "@/lib/utils";
import type { AdminEventSession } from "../types";

export function SessionsPanel(props: {
  sessions: AdminEventSession[];
  timezone: string;
  onAdd: () => void;
  onEdit: (session: AdminEventSession) => void;
  onRemove: (sessionId: string) => void;
}) {
  const { sessions } = props;
  return (
    <Panel header="Sessions">
      <div className="relative">
        <div
          className="absolute top-0 right-0 z-10"
          style={{ marginTop: "-3.5rem", marginRight: "0.5rem" }}
        >
          <Button
            icon="pi pi-plus"
            label="Add Session"
            className="p-button-sm"
            onClick={props.onAdd}
          />
        </div>
        <DataTable value={sessions} emptyMessage="No sessions" responsiveLayout="scroll">
          <Column
            field="label"
            header=""
            body={(rowData: AdminEventSession) => (
              <span className="font-bold">{rowData.label || "—"}</span>
            )}
          />
          <Column
            header="Starts at"
            body={(rowData: AdminEventSession) =>
              rowData.startsAt
                ? formatDateTime(rowData.startsAt, props.timezone)
                : "-"
            }
          />
          <Column
            header="Ends at"
            body={(rowData: AdminEventSession) =>
              rowData.endsAt ? formatDateTime(rowData.endsAt, props.timezone) : "-"
            }
          />
          <Column
            header=""
            style={{ width: "80px", maxWidth: "80px" }}
            body={(rowData: AdminEventSession) => (
              <div className="flex gap-2">
                <Button
                  icon="pi pi-pencil"
                  className="p-button-text p-button-sm"
                  onClick={() => props.onEdit(rowData)}
                  aria-label="Edit"
                />
                <Button
                  icon="pi pi-trash"
                  className="p-button-text p-button-sm p-button-danger"
                  onClick={() => props.onRemove(rowData.id)}
                  aria-label="Remove"
                  disabled={sessions.length === 1}
                />
              </div>
            )}
          />
        </DataTable>
      </div>
    </Panel>
  );
}


